import { useLogoutStudent } from '../../../../../modules/auth'
import { n_account, n_login } from '../../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import useLandingNav from '../useLandingNav'

const NavAuth = () => {
  const { isLogin, navigateToSignIn, navigateToPortalHome } = useLandingNav()
  const { t } = useTranslation()
  const logoutStudent = useLogoutStudent()

  const handleLogInClick = () => {
    if (isLogin) {
      logoutStudent()
    } else {
      navigateToSignIn()
    }
  }

  return (
    <li className="px-6 py-4 hover:bg-gray-50 rounded">
      <button onClick={handleLogInClick}>
        <span className="px-6 Body2-14Md text-gray-500 !font-[400]">
          {isLogin ? t(n_account.logout) : t(n_login.sign_text.btn)}
        </span>
      </button>
    </li>
  )
}

export default NavAuth
